import { Input, Typography } from '@breetometer/components';
import { SearchIcon } from 'BreetAssets';
import { DEFAULT_INPUT_MAX_LENGTH, type IDropDownItem } from 'BreetHelpers';
import { useClampMenuHeight } from 'BreetHooks';
import { type ChangeEvent, type MouseEvent, useCallback, useState } from 'react';

import type { ModernDropDownItemProps } from '../../Dropdown.helpers';
import ModernItemOptions from '../item-options/Modern';

export const ModernDropdownItems = ({
	handleItemSelect,
	items,
	selectedItem,
	handleClose,
	hideSearch,
	CustomItemOption,
	searchItemPlaceholder,
}: ModernDropDownItemProps) => {
	const [searchTerm, setSearchTerm] = useState('');

	const clampMenuHeight = useClampMenuHeight();

	const handleSearchTerm = useCallback((e: ChangeEvent<HTMLInputElement>) => {
		setSearchTerm(e.target.value);
	}, []);

	const handleItemSelection = useCallback(
		(item: IDropDownItem) => {
			const handler = handleItemSelect?.(item);

			return (e: MouseEvent<HTMLButtonElement>) => {
				setSearchTerm('');
				handler?.(e);
				handleClose();
			};
		},
		[handleItemSelect, handleClose]
	);

	const handleSearchFilter = useCallback(
		(item: IDropDownItem) => {
			const term = searchTerm.toLowerCase();

			return (
				item.name.toLowerCase().includes(term) ||
				item.value.toLowerCase().includes(term) ||
				item.code.toLowerCase().includes(term)
			);
		},
		[searchTerm]
	);

	const filteredItems = items.filter(handleSearchFilter);

	return (
		<div className='modern-dropdown_menu'>
			{!hideSearch && (
				<div className='modern-dropdown_menu_search'>
					<SearchIcon className='dropdown_content_item_search_icon' />
					<Input
						type='text'
						label=''
						id=''
						maxLength={DEFAULT_INPUT_MAX_LENGTH}
						value={searchTerm}
						onChange={handleSearchTerm}
						className='dropdown_content_item_search_input'
						widthType='full'
						placeholder={searchItemPlaceholder}
					/>
				</div>
			)}

			<div
				className='modern-dropdown_menu_options scrollbar'
				ref={clampMenuHeight}
			>
				<ModernItemOptions
					items={filteredItems}
					selectedItem={selectedItem}
					handleItemSelection={handleItemSelection}
					CustomItemOption={CustomItemOption}
				/>
				{filteredItems.length === 0 && (
					<div className='modern-dropdown_menu_empty'>
						<Typography
							as='p'
							variant='sub_head'
						>
							No data found
						</Typography>
					</div>
				)}
			</div>
		</div>
	);
};
